export const REDUCER_NAME = 'cbct-file-upload'

export const MAX_SCAN_FILE_SIZE = 90 * 1024 * 1024




// WEBPACK FOOTER //
// ./src/modules/customer/state/cbct-file-upload/const.js